module.exports = __webpack_public_path__ + "img/hyf-logo-mark-orange.b646f929.png";